import PropTypes from 'prop-types';

const annotationServiceShape = PropTypes.shape({
  isRegistered: PropTypes.func,
  register: PropTypes.func,
  authorAnnotationCreate: PropTypes.func,
  authorAnnotationGet: PropTypes.func,
  authorAnnotationList: PropTypes.func,
  getAnnotationsWithAccountList: PropTypes.func,
  authorAnnotationUpdate: PropTypes.func,
  authorAnnotationResolve: PropTypes.func,
  authorAnnotationDelete: PropTypes.func,
  authorAnnotationsDelete: PropTypes.func,
  authorAnnotationsRestore: PropTypes.func,
  authorAnnotationAggregate: PropTypes.func,
  getAnnotationsByMotivation: PropTypes.func,
  subscribeToAnnotationMotivation: PropTypes.func,
  createAnnotation: PropTypes.func,
  resolveAnnotation: PropTypes.func,
  setAnnotationBody: PropTypes.func,
  readAnnotation: PropTypes.func,
  unreadAnnotation: PropTypes.func,
  deleteAnnotation: PropTypes.func,
  notifyUpdate: PropTypes.func,
  getSubscribers: PropTypes.func,
  subscribeToEvent: PropTypes.func,
});

export default annotationServiceShape;
